import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { CoreProvider } from 'src/app/services/core';

export interface OkmodalOptions {
  message: string;
  timeout?: number;
}

@Component({
  selector: 'page-okmodal',
  styleUrls: ['okmodal.scss'],
  templateUrl: 'okmodal.html',
})
export class OkmodalPage implements OnInit {
  alredyNavigated: boolean = false;
  successText: string = '';

  constructor(public navParams: NavParams, private _modalCtrl: ModalController) {
    this.successText = this.navParams.data.message || '';
  }

  ngOnInit() {
    setTimeout(() => this.navigate(), this.navParams.data.timeout || 3000);
  }

  onClick = () => this.navigate();

  navigate() {
    if (this.alredyNavigated) return;
    this.alredyNavigated = true;
    this._modalCtrl.dismiss();
  }

  public static async Open(core: CoreProvider, options: OkmodalOptions={message:''}, cb: Function=null) {
    let modal = await core.modalCtrl.create({
      component: OkmodalPage,
      backdropDismiss: false,
      componentProps: options,
      cssClass: 'ok-modal'
    });
    if (cb) modal.onDidDismiss().then(() => cb());
    await modal.present();
  }

}
